import React, {useCallback, useEffect, useState} from 'react'
import {injectIntl} from "react-intl"
import {useDispatch, useSelector} from "react-redux"
import InputAdornment from "@mui/material/InputAdornment"
import TextField from "@mui/material/TextField";
import {Link, useNavigate, useParams} from 'react-router-dom'
import {registerUser, userSignOut} from "../../redux/actions/Auth"
import Snackbar from '@mui/material/Snackbar'
import MuiAlert from '@mui/material/Alert'
import {useFormik} from 'formik'
import * as yup from 'yup'
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import {changeLocale} from "../../redux/actions/Common";
import {getSetupData} from "../../redux/actions/List";
import {getLocale} from "../../utils/compute";
import MenuItem from "@mui/material/MenuItem";
import {capitalizeFirstLetter} from "../../utils/format";
import platformConfig from '../../config/config';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { getLanguage } from '../../redux/actions/List';
import {
    GoogleReCaptchaProvider,
    useGoogleReCaptcha
  } from 'react-google-recaptcha-v3';
import Recaptcha from './Recaptcha';

const Register = ({intl}) => {
    const dispatch = useDispatch()
    let navigate = useNavigate()

    const {register_success,token,user,recaptchaDataGeneral,imageVerified} = useSelector(({auth}) => auth)
    const {message, locale} = useSelector(({common}) => common)
    const {language} = useSelector(({list}) => list)
    const { name,code,logoPath,bgSecondary} = platformConfig;
    const [showModal, setShowModal] = useState(false);
    const breedjUrl = process.env.BREEDJ_URL;

    
    
    useEffect(() => {
        dispatch(getLanguage(token, {}, locale))
    },[locale.short])

    const handleClick = () => {
        if(token) {
            dispatch(userSignOut(token))
            window.location.href = breedjUrl;
        }
    };
    

    
    
    const onValidToken = useCallback((data, token, captchaType) => {
        let isValid = false;
    
        if (captchaType === 'v3') {
          if (data && data.success) {
            if (data.score >= 0.3) {
              isValid = true;
            } 
          }
        }

        if (captchaType === 'v2') {
          if (data && data.success) {
            isValid = true;
          }
        }
    
        setIsVerifiedCaptcha(isValid);
        setRecaptchaToken(token);
    }, [recaptchaDataGeneral,imageVerified]);   
      
    useEffect(() => {
    if(imageVerified.success) {
        setIsVerifiedCaptcha(true)
    }
    },[imageVerified])

    const [isVerifiedCaptcha, setIsVerifiedCaptcha] = useState(false);
    const [recaptchaToken, setRecaptchaToken] = useState('');
    const [showAlert, setShowAlert] = useState(false)
    const [alertMsg, setAlertMsg] = useState('')
    const [formTalent, setFormTalent] = useState({
        first_name: '',
        last_name: '',
        company_name: '',
        email: '',
        type: '',
        hear_about_us: '',
        platform_code: code
    })
    useEffect(() => {
        if(code === "talenteum") {
            setShowModal(true)
        }
    },[navigate])
    let {type} = useParams();
    const params = new URLSearchParams(window.location.search)
    const first_name = params.get('first_name')
    const last_name = params.get('last_name')
    const email = params.get('email')

    const company_name = params.get('company_name')

    let formFieldsTalent = {
        first_name: yup
            .string()
            .required(intl.formatMessage({id: 'this.field.is.required'})),
        last_name: yup
            .string()
            .required(intl.formatMessage({id: 'this.field.is.required'})),
        type: yup
            .string()
            .required(intl.formatMessage({id: 'this.field.is.required'})),
        email: yup
            .string()
            .email(intl.formatMessage({id: 'email.format.not.valid'}))
            .required(intl.formatMessage({id: 'this.field.is.required'})),
            hear_about_us: yup.string().required(intl.formatMessage({id: 'this.field.is.required'}))
    }

    let formFieldsCompany = {
        first_name: yup
            .string()
            .required(intl.formatMessage({id: 'this.field.is.required'})),
        last_name: yup
            .string()
            .required(intl.formatMessage({id: 'this.field.is.required'})),
        type: yup
            .string()
            .required(intl.formatMessage({id: 'this.field.is.required'})),
        company_name: yup
            .string()
            .required(intl.formatMessage({id: 'this.field.is.required'})),
        email: yup
            .string()
            .email(intl.formatMessage({id: 'email.format.not.valid'}))
            .required(intl.formatMessage({id: 'this.field.is.required'})),
            hear_about_us: yup.string().required(intl.formatMessage({id: 'this.field.is.required'}))
    }
    

    const validationSchema = yup.object(
        formTalent?.type === 'company'
            ? formFieldsCompany
            : formFieldsTalent
    );

    const formik = useFormik({
        initialValues: formTalent,
        validationSchema: validationSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            handleRegister()
        },
    })

    /*
    This is a hack. When coming form a link, this form is not updated.
    I dont know why. Remove at your own peril mortal
     */
    useEffect(() => {
        if (company_name) {
            setTimeout(function() {
                setFormTalent({
                    ...formTalent,
                    ['company_name']: company_name
                })
            }, 1000)
        }
    }, [company_name])


    useEffect(() => {
        setTimeout(function(){
            if(type !== 'new') {
                formTalent.type = type;
            }
            if (first_name) {
                formTalent.first_name = first_name;
            }
            if (last_name) {
                formTalent.last_name = last_name;
            }
            if (email) {
                formTalent.email = email;
            }
            
            setFormTalent(formTalent)
        }, 500)
    }, [type])

    useEffect(() => {
        if (locale) {
            formTalent.locale = locale.short;
            setFormTalent(formTalent)
        }
    }, [locale])

    useEffect(() => {
        if (register_success?.user?.email) {
            const encodedEmail = encodeURIComponent(register_success.user.email);
            navigate('/login/new?email=' + encodedEmail);
        }
    }, [register_success])

    useEffect(() => {
        if (type) {
            handleTextChange(type, 'type')
        }
    }, [])

    useEffect(() => {
        if (message === 'incorrect_credentials') {
            setShowAlert(true)
            setAlertMsg(intl.formatMessage({id: 'invalid.credentials'}))
        }

        if (message === 'account_blocked') {
            setShowAlert(true)
            setAlertMsg(intl.formatMessage({id: 'account.blocked'}))
        }

        if (message === 'error') {
            setShowAlert(true)
            setAlertMsg(intl.formatMessage({id: 'error.generic'}))
        }

        if (message === 'email_exist') {
            setShowAlert(true)
            setAlertMsg(intl.formatMessage({id: 'email.exist'}))
        }
        
        if (message === 'email_domain_not_allowed') {
            setShowAlert(true)
            setAlertMsg(intl.formatMessage({id: 'email.domain_not_allowed'}))
        }
    }, [message])

    const handleTextChange = (value, field) => {
        setFormTalent({
            ...formTalent,
            [field]: value
        })
    }

    const handleRegister = () => {
        formTalent.recaptcha_token = recaptchaToken;
        dispatch(registerUser(formTalent))
    }

    const howDidYouHearOptions = [
        { id: 1, value: 'website', label:  intl.formatMessage({id: 'websitehear'})},
        { id: 2, value: 'linkedin', label: intl.formatMessage({id: 'linkedin'})},
        { id: 3, value: 'online_ads', label: intl.formatMessage({id: 'online_ads'})},
        { id: 4, value: 'word_of_mouth', label: intl.formatMessage({id: 'word_of_mouth'})},
        { id: 5, value: 'referral', label: intl.formatMessage({id: 'referral'}) },
        { id: 6, value: 'event', label: intl.formatMessage({id: 'event'}) },
        { id: 7, value: 'other', label: intl.formatMessage({id: 'others'}) },
      ];

      const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 600,
        bgcolor: 'background.paper',
        boxShadow: 24,
        outline: 'none',
        p: 4,
        borderRadius: '16px',
      };
      
    return (
        <div className="login-container">
            <header className="py-2 flex flex-col space-y-5 justify-center items-center">
                <Link to={'/login'}>
                     <img src={logoPath} className="w-96 cursor-pointer" alt="Logo de images"/>
                </Link>
                
                <h1 className="py-3 px-6 rounded-full shadow-xxl font-semibold text-green-600 text-xl text-center">
                    {intl.formatMessage({id: 'register.message'},{name})}
                </h1>
            </header>
               <Modal
                        open={showModal}
                        // onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={style}>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            {intl.formatMessage({id:"registerMigrationTalenteumToBreedjTitle"})}
                        </Typography>
                        <div className='flex items-center justify-center text-center  gap-2 mt-4'>          
                            <a 
                            href="https://www.hire.breedj.com"
                            className={`px-8 py-2  text-white bg-[#0284c7] cursor-pointer w-full rounded-full`}
                            >
                            {intl.formatMessage({id:"ConnectToBreedj"})}
                            </a>
                        </div>
                        <div className='flex items-center justify-center'>
                            <a 
                            href='https://breedj.freshdesk.com/support/tickets/new'
                            className={`px-8 py-2  text-[${bgSecondary}] underline`}
                            target='_blank'
                            >
                                {intl.formatMessage({id:'contactSupportMessage'})}
                            </a>
                        </div>
                        

                        </Box>
                    </Modal>

            <main className="my-8 flex justify-center">
                <form
                    className="xs:w-11/12 sm:w-7/12 grid lg:grid-cols-2 md:grid-cols-1 gap-x-10 gap-y-5 place-content-center  xl:grid"
                    onSubmit={formik.handleSubmit}>
                    <section  className="shadow-xxl rounded-4xl md:block hidden">
                        <img src={require('./../../assets/images/register-step-one.jpg')} alt="Image de login"
                             className="rounded-4xl responsive_height"/>
                    </section>

                    <section className="shadow-xxl rounded-4xl flex justify-center flex-col p-8 md:w-full">
                        <section className="w-full flex-1 mt-4 m-x-4">
                            <FormControl className={'w-full'}>
                                <InputLabel id="demo-simple-select-standard-label">
                                    {intl.formatMessage({id: 'type'})}
                                </InputLabel>
                                <Select
                                    value={formTalent.type || ''}
                                    label={intl.formatMessage({id: 'type'})}
                                    onChange={(e) => handleTextChange(e?.target?.value, 'type')}
                                    className={'text-left'}
                                    error={formik.touched.type && Boolean(formik.errors.type)} 
                                >
                                    <MenuItem key={1} value={'talent'}>
                                        {intl.formatMessage({id: 'a.talent'})}
                                    </MenuItem>
                                    <MenuItem key={2} value={'company'}>
                                        {intl.formatMessage({id: 'a.company'})}
                                    </MenuItem>
                                </Select>

                                {formik.touched.type && formik.errors.type && (
                                    <div className="text-red-600 text-xs ml-3 mt-1">{formik.errors.type}</div>
                                )}
                            </FormControl>
                        </section>
                        {
                            formTalent.type == 'company' ?

                                company_name ?
                                    <section className="w-full flex-1 mt-4 m-x-4">
                                        <TextField
                                            label={intl.formatMessage({id: 'company.name'})}
                                            className={'w-full'}
                                            defaultValue={company_name || ''}
                                            id="formatted-numberformat-input"
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">
                                                    <i className={'fa-solid fa-building text-secondary'}></i>
                                                </InputAdornment>,
                                            }}
                                            onChange={(e) => handleTextChange(e?.target?.value, 'company_name')}
                                            error={formik.touched.company_name && Boolean(formik.errors.company_name)}
                                            helperText={formik.touched.company_name && formik.errors.company_name}
                                        />
                                    </section>
                                    :
                                    <section className="w-full flex-1 mt-4 m-x-4">
                                        <TextField
                                            label={intl.formatMessage({id: 'company.name'})}
                                            className={'w-full'}
                                            defaultValue={formik.values.company_name || ''}
                                            id="formatted-numberformat-input"
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">
                                                    <i className={'fa-solid fa-building text-secondary'}></i>
                                                </InputAdornment>,
                                            }}
                                            onChange={(e) => handleTextChange(e?.target?.value, 'company_name')}
                                            error={formik.touched.company_name && Boolean(formik.errors.company_name)}
                                            helperText={formik.touched.company_name && formik.errors.company_name}
                                        />
                                    </section>
                                : ''
                        }

                        <section className="w-full flex-1 mt-4 m-x-4">
                            <TextField
                                label={intl.formatMessage({id: 'first.name'})}
                                className={'w-full'}
                                value={formTalent?.first_name}
                                id="formatted-numberformat-input"
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">
                                        <i className={'fa-solid fa-circle-user text-secondary'}></i>
                                    </InputAdornment>,
                                }}
                                onChange={(e) => handleTextChange(e?.target?.value, 'first_name')}
                                error={formik.touched.first_name && Boolean(formik.errors.first_name)}
                                helperText={formik.touched.first_name && formik.errors.first_name}
                            />
                        </section>

                        <section className="w-full flex-1 mt-4">
                            <TextField
                                label={intl.formatMessage({id: 'last.name'})}
                                className={'w-full'}
                                value={formTalent?.last_name}
                                id="formatted-numberformat-input"
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">
                                        <i className={'fa-regular fa-user text-secondary'}></i>
                                    </InputAdornment>,
                                }}
                                onChange={(e) => handleTextChange(e?.target?.value, 'last_name')}
                                error={formik.touched.last_name && Boolean(formik.errors.last_name)}
                                helperText={formik.touched.last_name && formik.errors.last_name}
                            />
                        </section>

                        <section className="w-full flex-1 mt-4">
                                <TextField
                                    label={intl.formatMessage({id: 'email'})}
                                    className={'w-full'}
                                    value={formTalent?.email}
                                    //defaultValue={formik.values.email || ''}
                                    id="formatted-numberformat-input"
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">
                                            <i className={'fa fa-envelope text-secondary'}></i>
                                        </InputAdornment>,
                                    }}
                                    onChange={(e) => {
                                        let fieldValue = e?.target?.value
                                        handleTextChange(fieldValue.trim(), 'email')
                                    }}
                                    error={formik.touched.email && Boolean(formik.errors.email)}
                                    helperText={formik.touched.email && formik.errors.email}
                                />
                        </section>
                        <section className="w-full flex-1 mt-4 m-x-4">
                            <FormControl className={'w-full'}>
                                <InputLabel id="demo-simple-select-standard-label">
                                    {intl.formatMessage({id: 'How_did_you_hear_about_us?'})}
                                </InputLabel>
                                <Select
                                    value={formTalent.hear_about_us || ''}
                                    label={intl.formatMessage({id: 'How_did_you_hear_about_us?'})}
                                    onChange={(e) => handleTextChange(e?.target?.value, 'hear_about_us')}
                                    error={formik.touched.hear_about_us && Boolean(formik.errors.hear_about_us)} 
                                    className={'text-left'}
                                >
                                    {howDidYouHearOptions?.map(option => {
                                        return (
                                            <MenuItem key={option.id} value={option.value}>
                                                {capitalizeFirstLetter(option.label)}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>
                            {formik.touched.hear_about_us && formik.errors.hear_about_us && (
                                <div className="text-red-600 text-xs ml-3 mt-1">{formik.errors.hear_about_us}</div>
                            )}
                        </section>

                        <GoogleReCaptchaProvider reCaptchaKey="6LfQUukqAAAAACRvPrgoilFPQfG7Qf3h8BZ9dPIa">
                            <Recaptcha onValidToken={onValidToken} />
                        </GoogleReCaptchaProvider>


                        {
                            isVerifiedCaptcha ? 
                                <div className="flex-1 flex justify-center items-end mt-4">
                                    <button type="submit" className="px-16 py-2 bg-secondary rounded-full text-white">
                                        {intl.formatMessage({id: 'validate'})}
                                    </button>
                                </div>
                            : ''
                        }

                        <div className="flex-1 flex justify-center items-end mt-4 text-xs">
                            <div>
                                {intl.formatMessage({id: 'by.click.validate'})}
                                <a href="/conditions-generales-de-vente-et-dutilisation-de-talenteum.pdf"
                                   className="text-secondary"
                                   target="_blank"> {intl.formatMessage({id: 'cgu.cgv'})}</a> {intl.formatMessage({id: 'and.special'})}
                                <a href="/centre-de-protection-des-donnees.pdf" className="text-secondary"
                                   target="_blank"> {intl.formatMessage({id: 'policy.confidentiality'})}</a> {intl.formatMessage({id: 'of.breedj'},{name})}
                            </div>
                        </div>

                        <hr className={'mt-4'} />

                        <button type="button"
                                className="px-8 py-2 text-secondary border-2 border-secondary rounded-full flex items-center justify-center w-full mt-4"
                                onClick={() => {
                                    window.location.replace(process.env.REACT_APP_API_URL + 'linkedin/auth/redirect')
                                }}
                        >
                            <img src={require('./../../assets/images/linkedin_logo_initials.png')} alt="Logo linkedin"
                                 className="rounded-4xl responsive_height !w-6 mr-4"/>
                            {intl.formatMessage({id: 'register.linkedin'})}
                        </button>
                    </section>

                    <section></section>

                    <section className="flex justify-center items-center space-x-4 text-xs">
                        <Link to={'/login'} className="px-4 py-1 rounded-full bg-secondary cursor-pointer text-white">
                            {intl.formatMessage({id: 'login'})}
                        </Link>
                        <FormControl className={'ml-4'}>
                            <InputLabel id="demo-simple-select-standard-label">
                                {intl.formatMessage({id: 'language'})}
                            </InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                value={locale.short}
                                label={intl.formatMessage({id: 'language'})}
                                onChange={(e) => {
                                    dispatch(changeLocale(getLocale(e.target.value)))
                                    dispatch(getSetupData(token, e.target.value))
                                }}
                                className={'text-left'}
                                size={'small'}
                            >
                                <MenuItem value={'fr'}>
                                    Français
                                </MenuItem>
                                <MenuItem value={'en'}>
                                    English
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </section>
                </form>
             


            </main>

            <Snackbar
                open={showAlert} //autoHideDuration={6000}
                onClose={() => setShowAlert(false)} anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
            >
                <MuiAlert onClose={() => setShowAlert(false)} severity="error" sx={{width: '100%'}}>
                    {alertMsg}
                </MuiAlert>
            </Snackbar>
        </div>
    )
}

export default injectIntl(Register)
